import Template from "./template.jsx";
import useStore from "../../../../../lib/itn-ui-kit/data/store";
import BaseRoute from "../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../lib/itn-ui-kit/services/service-container";

export default class MedicalRecordsCasesDetailRoute extends BaseRoute {
  @service('repositories/case-repository') caseRepository;


  element = <Template />;

  async loader({ request, params}) {
    const defaultParams = {
      "data-set":"search",
    }
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    let newSearchParams = Object.assign(searchParams, defaultParams);
    const cases = await this.caseRepository.query(newSearchParams);
    const count = useStore.getState().getTotalCount("case");
  
    return {
      cases,
      count,
};
  }
}
